module.exports = __webpack_public_path__ + "img/WPS-2.8078e1ff.jpg";